export default {
  name: 'my-tasks',
  translationKey: 'my-tasks-module',
  routePrefix: 'my-tasks',
  routeNamePrefix: 'my-tasks',
  directRoutesAvailable: true,
}
